@if (event$ | async; as event) {
  <div
    class="flex flex-col lg:flex-row justify-center py-5 px-8 lg:py-6 gap-6 lg:gap-16 bg-black"
    [ssDirectus]="{
      collection: 'showDetails',
      item: showDetailsId(),
      fields: ['show'],
    }"
  >
    @if (event.eventDetails?.theaterLocation) {
      <div>
        <h6>Location</h6>
        <h4 class="mt-2">
          {{ (event.eventDetails!.theaterLocation | locationInfo).name }}
        </h4>
      </div>
    }
    <div>
      <h6>Dates</h6>
      <h4 class="mt-2">
        {{ startDate$ | async }} – {{ endDate$ | async }},
        {{ event.eventDetails?.eventEndDate | date: 'y' }}
      </h4>
    </div>
    <div>
      <h6>Runtime</h6>
      <h4 class="mt-2">{{ runTime$ | async }}</h4>
    </div>
    <div>
      <h6>adult price (ages 13+)</h6>
      <h4 class="mt-2">
        {{ (event.eventPriceListDetail | showPriceInfo)?.adultPriceList }}
      </h4>
    </div>
    <div>
      <h6>children (ages 2–12)</h6>
      <h4 class="mt-2">
        {{ (event.eventPriceListDetail | showPriceInfo)?.childPriceList }}
      </h4>
    </div>
  </div>
}
